import { useEffect, useState } from "react";

const STATS_URL = "/api/discord-stats";

let _cache = null;
let _cacheAt = 0;
const TTL_MS = 30000;

const subscribers = new Set();

async function refresh() {
  try {
    const res = await fetch(STATS_URL, { cache: "no-store" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = await res.json();
    _cache = { data: json, error: null };
    _cacheAt = Date.now();
  } catch (e) {
    _cache = { data: null, error: e.message || "fetch failed" };
    _cacheAt = Date.now();
  }
  subscribers.forEach((cb) => cb());
}

export default function useDiscordWidget() {
  const [, force] = useState(0);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    const cb = () => force((v) => v + 1);
    subscribers.add(cb);

    const stale = !_cache || Date.now() - _cacheAt > TTL_MS;
    if (stale) {
      refresh().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }

    const t = setInterval(() => {
      if (document.visibilityState === "visible") refresh();
    }, 60000);

    return () => {
      subscribers.delete(cb);
      clearInterval(t);
    };
  }, []);

  return {
    data: _cache?.data || null,
    error: _cache?.error || null,
    loading,
  };
}
